import FlightSearchWrapper from "./FlightSearchArea";
import SearchForm from "component/Home/SearchForm";
import { useFlightContext } from "hooks/flight/useFlightContext";
import { Navigate } from "react-router-dom";

const FlightSearchArea = () => {
    const { flightSearchParams, availabiltyResults } = useFlightContext();

    if (
        !flightSearchParams?.arrivalOption1 &&
        !flightSearchParams?.arrivalOption1 &&
        !flightSearchParams?.departureDate1 &&
        !availabiltyResults
    ) {
        return <Navigate to="/?tab=flight" />;
    }

    return (
        <>
            <SearchForm />
            <FlightSearchWrapper />
        </>
    );
};

export default FlightSearchArea;
